/**
 * Mirror of customer-api/src/orderDeposit.js for Customer HQ.
 */

export const DEPOSIT_RECEIVER = "deposit-to-qiktruck";

export function parseCents(value) {
  const n = Math.round(Number(value) || 0);
  return n < 0 ? 0 : n;
}

export function depositRequiredCents(order = {}) {
  const required = parseCents(order.deposit_required_cents);
  return required > 0 ? required : 0;
}

export function depositPaidCents(order = {}) {
  return parseCents(order.deposit_paid_cents);
}

export function isDepositRequired(order = {}) {
  return depositRequiredCents(order) > 0;
}

export function depositOutstandingCents(order = {}) {
  const required = depositRequiredCents(order);
  if (!required) return 0;
  return Math.max(required - depositPaidCents(order), 0);
}

export function isDepositSatisfied(order = {}) {
  if (!isDepositRequired(order)) return true;
  return depositPaidCents(order) >= depositRequiredCents(order);
}

export function isDepositReceiverCustomerPaid(order = {}) {
  const receiver = String(order.paymentreceiver || "").toLowerCase();
  if (receiver !== DEPOSIT_RECEIVER) return false;
  if (!isDepositRequired(order)) return true;
  return isDepositSatisfied(order);
}
